import { type Entry } from '../../generated/sinch/chat/sdk/v1alpha2/resources_pb.ts'
import type { AppMessage } from '../../generated/sinch/conversationapi/type/conversation_message_pb.ts'

export function getIsAgentInConversation(entries: Entry[]) {
  let isAgentEventInEntries = false

  const agentInConversation = entries.reduce((agentInConversationTemp, entry) => {
    switch (entry.payload.case) {
      case 'appEvent':
        switch (entry.payload.value.event.case) {
          case 'agentJoinedEvent':
            isAgentEventInEntries = true
            return true
          case 'agentLeftEvent':
            isAgentEventInEntries = true
            return false
        }
    }
    return agentInConversationTemp
  }, false)

  if (agentInConversation) {
    return true
  }

  if (!agentInConversation && isAgentEventInEntries) {
    return false
  }

  return isLastAppMessageFromAgent(entries)
}

function isLastAppMessageFromAgent(entries: Entry[]) {
  const lastAppMessage = entries
    .slice()
    .reverse()
    .find(entry => entry.payload.case === 'appMessage')?.payload.value as AppMessage | undefined

  return lastAppMessage?.agent !== undefined && lastAppMessage.agent.displayName !== 'Contact center'
}
